import React from "react";
import { useNavigate } from "react-router-dom";
import {
  Card,
  CardContent,
  CardActionArea,
  Typography,
  Box,
  Chip,
  IconButton,
} from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

import { Service } from "../../types";
import { serviceService } from "../../services";
import { ServiceIcon } from "../common";

interface ServiceCardProps {
  service: Service;
}

const ServiceCard: React.FC<ServiceCardProps> = ({ service }) => {
  const navigate = useNavigate();
  const durationOptions = serviceService.getDurationOptions(service);

  const handleClick = () => {
    navigate(`/services/${service.id}`);
  };

  return (
    <Card
      sx={{
        height: "100%",
        transition: "all 0.2s ease-in-out",
        "&:hover": {
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
        },
      }}
    >
      <CardActionArea onClick={handleClick} sx={{ height: "100%" }}>
        <CardContent
          sx={{
            height: "100%",
            display: "flex",
            flexDirection: "column",
            p: 2.5,
          }}
        >
          <Box
            sx={{ display: "flex", alignItems: "flex-start", gap: 2, mb: 2 }}
          >
            <ServiceIcon serviceName={service.name} size={48} />
            <Box sx={{ flex: 1, minWidth: 0 }}>
              <Typography
                variant="h6"
                component="h3"
                noWrap
                sx={{
                  fontWeight: 600,
                  color: "text.primary",
                  mb: 0.5,
                }}
              >
                {service.name}
              </Typography>
              <Chip
                label={
                  durationOptions.length +
                  " duration" +
                  (durationOptions.length > 1 ? "s" : "")
                }
                size="small"
                sx={{
                  height: 22,
                  fontSize: "0.7rem",
                  bgcolor: "#f3f4f6",
                  color: "#6b7280",
                }}
              />
            </Box>
          </Box>

          <Typography
            variant="body2"
            sx={{
              color: "text.secondary",
              flex: 1,
              mb: 2,
              display: "-webkit-box",
              WebkitLineClamp: 2,
              WebkitBoxOrient: "vertical",
              overflow: "hidden",
            }}
          >
            {service.description ||
              "Deploy and manage " + service.name + " instances on demand."}
          </Typography>

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
              pt: 2,
              borderTop: "1px solid",
              borderColor: "#f3f4f6",
            }}
          >
            <IconButton
              size="small"
              sx={{
                bgcolor: "#f9fafb",
                "&:hover": { bgcolor: "#f3f4f6" },
                color: "#6b7280",
              }}
            >
              <ArrowForwardIcon fontSize="small" />
            </IconButton>
          </Box>
        </CardContent>
      </CardActionArea>
    </Card>
  );
};

export default ServiceCard;
